import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageTitleState {
  title: string;
  icon: string;
  isMaterial: boolean;
  materialClass?: string;
}

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private state = new BehaviorSubject<PageTitleState>({ title: '', icon: '', isMaterial: false });
  readonly title$ = this.state.asObservable();
  set(title: string, icon: string, isMaterial = false, materialClass = 'material-icons-outlined'): void {
    setTimeout(() => this.state.next({ title, icon, isMaterial, materialClass }));
  }
}
